export interface WebhookData {
  timestamp: string;
  filename: string;
  totalPositions: number;
  positions: Array<{
    id: number;
    originalId: string;
    gewerk: string;
    name?: string;
    beschreibung: string;
    einheit: string;
    preis: number;
    umsatzsteuer: number;
    menge?: number;
  }>;
  metadata: {
    source: 'excel_upload';
    version: '1.1';
    userAgent: string;
  };
}

const WEBHOOK_URL = 'https://n8n.smeshr.com/webhook/42f386fa-136d-4636-8dc8-c4beadce6166';

export async function sendWebhookData(filename: string, positions: any[]): Promise<boolean> {
  try {
    const webhookData: WebhookData = {
      timestamp: new Date().toISOString(),
      filename: filename,
      totalPositions: positions.length,
      positions: positions.map(pos => ({
        id: pos.id,
        originalId: pos.originalId || '',
        gewerk: pos.gewerk || '',
        name: pos.name || '',
        beschreibung: pos.beschreibung || '',
        einheit: pos.einheit || '',
        preis: pos.preis || 0,
        umsatzsteuer: pos.umsatzsteuer || 19,
        menge: pos.menge || 1
      })),
      metadata: {
        source: 'excel_upload',
        version: '1.1',
        userAgent: navigator.userAgent
      }
    };

    console.log('Sending webhook data:', {
      url: WEBHOOK_URL,
      filename: filename,
      positionCount: positions.length
    });

    const response = await fetch(WEBHOOK_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(webhookData),
    });

    if (!response.ok) {
      throw new Error(`Webhook failed with status: ${response.status}`);
    }

    console.log('Webhook sent successfully:', response.status);
    return true;
  } catch (error) {
    console.error('Webhook error:', error);
    return false;
  }
} 